module.exports = __webpack_public_path__ + "img/flowPath-item3-on.fab1c6a4.png";